<template>
    <div><!-- 訂單/訂單變更查詢 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{headerText}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="plant">
                                <p>{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                     <input :disabled ="disableFactory" type="radio" :name="searchType + '_FactoryTypeOpt'" v-model="orderQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                </div>                                
                            </div>
                            <div class="supplier">
                                <p>{{$t('OrderInfo_Vue.VendorId')}}：</p>
                                <input type="text" v-if="isDisableVendorId" :disabled="isDisableVendorId" v-model="orderQueryParam.vendorId">
                                <Select2 style="width: 500px;" v-if="!isDisableVendorId" v-model="orderQueryParam.vendorIdList" :options="memberListFilter(orderQueryParam.factoryId)" :settings="{ 'multiple': 'true' }" />
                            </div>
                            <div class="date_range">
                                <p>{{$t('OrderInfo_Vue.OrderDate')}}：</p>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="orderQueryParam.orderDateBegin"></date-picker>
                                <span>~</span>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="orderQueryParam.orderDateEnd"></date-picker>
                            </div>
                            <div class="number_range">
                                <p>{{$t('OrderInfo_Vue.OrderNo')}}：</p>
                                <input type="text" maxlength="15" v-model="orderQueryParam.orderNoBegin">
                                <span>~</span>
                                <input type="text" maxlength="15" v-model="orderQueryParam.orderNoEnd">
                            </div>
                            <div class="watch">
                                <p>{{$t('OrderInfo_Vue.OrderViewed')}} ：</p>
                                <div v-for="(item, key) in viewList" :key="'view_input' + key">
                                    <input type="radio" name="OrderViewed" v-model="orderQueryParam.isViewed" :value="item.viewId"> {{item.viewCaption}}
                                </div>
                                <!-- <input type="radio" name="OrderViewed" v-for="(item, key) in viewList" :key="'view_input' + key" v-model="orderQueryParam.isViewed" :value="item.viewId"> {{item.viewCaption}} -->
                                <!-- <input type="radio" name="OrderViewed" v-model="orderQueryParam.isViewed" value="Y"> 是{{$t('QuoteInfo_Vue.FactoryType')}}
                                <input type="radio" name="OrderViewed" v-model="orderQueryParam.isViewed" value="N"> 否
                                <input type="radio" name="OrderViewed" v-model="orderQueryParam.isViewed" value=""> 全部 -->
                            </div>

                            <div class="check">
                                <p>{{$t('OrderInfo_Vue.OrderConfirm')}}：</p>
                                <div v-for="(item, key) in vendorConfirmList" :key="'orderConfirm_input' + key">
                                    <input type="radio" name="OrderConfirm" v-model="orderQueryParam.isConfirm" :value="item.vendorConfirmId"> {{item.vendorConfirmCaption}}
                                </div>
                                <!-- <input type="radio" name="OrderConfirm" v-model="orderQueryParam.isConfirm" value="N"> 未確認
                                <input type="radio" name="OrderConfirm" v-model="orderQueryParam.isConfirm" value="Y"> 已確認
                                <input type="radio" name="OrderConfirm" v-model="orderQueryParam.isConfirm" value=""> 全部 -->
                            </div>
                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="ordersSearchEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" v-if="isOrder" class="btn btn-info mr-2" @click="exportOrderEvent">{{$t('Buttons.ExportOrder')}}</button>
                                <router-link class="btn btn-blue" v-if="isOrder" to="" @click.native="reportOrderEvent">{{$t('Buttons.ReportOrder')}}</router-link>                                
                            </div>                            
                        </div>
                    </CForm>                
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            factoryList: this.$t('factoryVNList'), //廠別 清單
            viewList: this.$t('viewList'), //看過否 清單
            vendorConfirmList: this.$t('vendorConfirmList'), //廠商確認清單
            orderQueryParam :{                
                factoryId: '',
                isViewed : '',
                isConfirm : '',
                vendorIdList:[],
                orderDateBegin : new Date().addDays(-14).yyyymmdd(),//近15天的日期區間，即[系統當日-15+1]~[系統當日]
                orderDateEnd : new Date().yyyymmdd(),
            },
            isDisableVendorId : false
            
        }
    },
    props : {
        searchType : String
    },
    watch: {
        lang: function() {
            this.factoryList = this.$t('factoryVNList') //廠別 清單
            this.viewList = this.$t('viewList') //看過否 清單
            this.vendorConfirmList = this.$t('vendorConfirmList') //廠商確認清單
        }
    },
    methods: {
        checkSearchParam(){ //檢核條件
           const {orderDateBegin,orderDateEnd,orderNoBegin,orderNoEnd} =this.orderQueryParam;
           let errMsg = '';
           if(orderDateBegin && orderDateEnd){
               if(orderDateBegin>orderDateEnd){
                 errMsg='訂單日期區間錯誤，起始日不得大於終止日!';
               }
           }        
           if(orderNoBegin && orderNoEnd){
               if(orderNoBegin>orderNoEnd){
                 errMsg='訂單單號區間錯誤，起始單號不得大於終止單號!';
               }
           }
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        ordersSearchEvent (){  
            if(!this.checkSearchParam()){
                return;
            }
            if(this.isOrder){
                this.orderSearchObj.totalCount
                this.$emit('doOrderSearch',this.orderQueryParam);//訂單查詢
            }else {
                 this.$emit('doChangeOrderSearch',this.orderQueryParam);//訂單變更查詢
            }
        },        
        exportOrderEvent (){//匯出        
            const url = `${this.$apiUrl_Order}/PrepareSearchOrderExport`;
            this.axios.post(url, this.orderQueryParam).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Order}/SearchOrderExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('orderExportExcel',urlExcel);
            })
        },
        reportOrderEvent (){//訂單狀況查詢報表
            this.setCacheQueryParam('Report_QueryParam' , this.orderQueryParam);
            this.$router.push("orderstatus");
        }
    },
    computed: {
        ...mapGetters(['lang']),
        isOrder (){
            if(this.searchType === 'Order'){
                return true;
            }else{
                return false;
            }
        },
        headerText (){
            if(this.isOrder){
                return this.$t('SearchBar_Vue.DocumentQueryHeaderText');
            }else {
                return this.$t('SearchBar_Vue.DocumentChangeQueryHeaderText');
            }
        },
        disableFactory (){
            if(this.isMember){
                return true;
            }else if(!this.isAdmin){
                return true;
            }
            return false;
        }
    },
    mounted() {
        let userInfo = this.$userInfo ;
        if(this.isMember){
            this.orderQueryParam.vendorId = userInfo.vendorId;
            this.isDisableVendorId =true;
        }
        this.getCacheQueryParam(this.searchType + '_QueryParam' , this.orderQueryParam);
        const userFactoryId = this.$userInfo.userFactory; 
        this.orderQueryParam.factoryId = userFactoryId;
        this.ordersSearchEvent();        
        if(!this.isMember){
            this.initMemberList();
        }
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .plant, .supplier, .date_range, .number_range, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
        > div {
             margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

.btn-blue {
    background-color: #1045e6;
    color: white;
}
</style>
